import { Scenarios } from '@jfs/network'

const validateBeneficiaryWithAmountDeductionApi = {
  default: [
    {
      url: /beneficiary\/validate/,
      method: 'POST',
      response: {
        responseCode: '01',
        responseMessage: 'PENDING',
        responseData: {
          rrn: '467433039740',
          transactionId: '10672229443303974000',
          originalId: '10012229443311717000',
          idempotentKey: '0803216725938203_1',
          transactionNetAmount: 2.54,
          transactionGrossAmount: 3.0,
          transactionTime: 'Fri Oct 21 12:01:51 IST 2022',
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /beneficiary\/validate/,
      method: 'POST',
      responseCode: 501,
      response: { status: 'FAILURE', error: { code: '33607', message: 'INVALID.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { validateBeneficiaryWithAmountDeductionApi }
